'use client';

import { __awaiter, __generator } from '../../_virtual/_tslib.js';
import { ELanguage } from '../../Utils/constants.js';
import ModelError from '../../services/model/index.js';

var UPDATE_INFO_API = '/api-gateway/v1.0/profile/basic-info';
function updateUserInfo(params, body) {
    return __awaiter(this, void 0, void 0, function () {
        var response, data, error_1, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch(params.baseMsUrl + UPDATE_INFO_API, {
                            method: 'POST',
                            headers: {
                                Authorization: "Bearer ".concat(params.accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': params.langCode
                            },
                            body: JSON.stringify(body)
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    if (response.ok) {
                        return [2 /*return*/, data];
                    }
                    return [2 /*return*/, new ModelError({
                            error: {
                                message: data.message || data.error || ''
                            }
                        })];
                case 3:
                    error_1 = _a.sent();
                    if (error_1.message === 'Timeout' ||
                        error_1.message === 'Network request failed' ||
                        error_1.message === 'Failed to fetch') {
                        data = {
                            data: {
                                ERR_INTERNET_DISCONNECTED: 'ERR_INTERNET_DISCONNECTED'
                            },
                            error: {
                                message: params.langCode === ELanguage.EN
                                    ? 'No internet connection. Please check your internet connection and try again.'
                                    : 'Không có kết nối Internet. Vui lòng kiểm tra kết nối internet của bạn và thử lại.',
                                status: 503
                            }
                        };
                        return [2 /*return*/, new ModelError(data)];
                    }
                    return [2 /*return*/, new ModelError(error_1)];
                case 4: return [2 /*return*/];
            }
        });
    });
}

export { updateUserInfo };
//# sourceMappingURL=update-info.js.map
